import { Container, Grid } from '@material-ui/core';

import { ChildrenProps } from 'types/children';
import SubTitle from 'components/shared/Title/SubTitle';
import { flexCss } from 'styles/utils';
import { css } from '@emotion/react';

const titleRowCss = css`
	gap: 16px;
	align-items: center;
	justify-content: flex-start;
`;

interface HeaderProps {
	title?: string;
	titleComponent?: React.ReactNode;
}

function TwoColumnLayout({ children }: ChildrenProps) {
	return (
		<Container maxWidth="lg">
			<Grid container spacing={3}>
				{children}
			</Grid>
		</Container>
	);
}

function Main({ children }: ChildrenProps) {
	return (
		<Grid item sm={12} md={9}>
			{children}
		</Grid>
	);
}

function Header({ children, title, titleComponent }: ChildrenProps & HeaderProps) {
	return (
		<>
			{title && (
				<div css={[flexCss, titleRowCss]}>
					<SubTitle text={title} /> {titleComponent}
				</div>
			)}
			<Grid container spacing={2} justify="space-between">
				{children}
			</Grid>
		</>
	);
}

function Content({ children }: ChildrenProps) {
	return <>{children}</>;
}

function Sidebar({ children }: ChildrenProps) {
	return (
		<Grid item sm={12} md={3}>
			{children}
		</Grid>
	);
}

TwoColumnLayout.Main = Main;
TwoColumnLayout.Header = Header;
TwoColumnLayout.Content = Content;
TwoColumnLayout.Sidebar = Sidebar;

export default TwoColumnLayout;
